import { Injectable } from '@angular/core';
import { StrapiGetListParameters } from '@core/const';
import { PLATFORM_FILTER_PARAMETER, StrapiCollectionEntityByCityApiService } from '@core/data-access';
import { SmartBannerEntity, SmartBannerEntityStrapi } from '@main/smart-banner/const';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SmartBannerApiService extends StrapiCollectionEntityByCityApiService<SmartBannerEntityStrapi> {
  constructor() {
    super('smart-banners', 'citiesIncluded', 'citiesExcluded');
  }

  getSmartBannerData(cityCode: string): Observable<SmartBannerEntity | null> {
    const params = { filters: PLATFORM_FILTER_PARAMETER } as StrapiGetListParameters<any>;
    return this.getListByCity(params, cityCode).pipe(
      map((smartBanners) => {
        if (!smartBanners?.length) {
          return null;
        }

        const banner = smartBanners[0];

        return {
          title: banner.title,
          description: banner.description || [],
        };
      }),
    );
  }
}
